module.exports = __webpack_public_path__ + "img/section1.5d28f213.svg";